import axios from "axios";
import config from '@config'
import { get, remove } from "local-storage";
import useUserDispatcher from "./useGlobalState/useUserDispatcher";


export const useAxios = () => {
    const { clearUserAuthData } = useUserDispatcher()
    
    const instance = axios.create({
        baseURL: config.API_BASEURL
    });


    instance.interceptors.request.use(async function (config) {
        const token = get<string>('token')

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config

    }, function (error) {
        return Promise.reject(error)
    })

    instance.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
        if (error.response.status === 401) {
            remove('token')
            remove('refreshToken')
            clearUserAuthData()
        } else {
            return Promise.reject(error);
        }

    });


    return instance
}